import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-btn-primary-black',
  templateUrl: './btn-primary-black.component.html',
  styleUrls: ['./btn-primary-black.component.css']
})
export class BtnPrimaryBlackComponent implements OnInit {

  @Output() callOnClick: EventEmitter<string> = new EventEmitter();
  @Input() btnLabel: string;
  @Input() isDisabled: string;

  constructor() { }

  ngOnInit() {
  }

  onBtnClick(): boolean {
    if (this.isDisabled === 'true') {
      return false;
    }
  
    // alert('clicked btn in child component');
    this.callOnClick.emit();
    return true;
  }

}
